import React from 'react';
import { Tabs, Card } from 'antd';
import {
  AiOutlineUnorderedList,
  AiOutlineForm,
  AiOutlineNodeExpand,
  AiOutlineDashboard,
} from 'react-icons/ai';
import { BsCardChecklist } from 'react-icons/bs';
const { TabPane } = Tabs;

const Sidebar = ({ activeTab, setActiveTab }) => {
  const getTabLabel = (key, icon, label) => (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        color: activeTab === key ? '#722ED1' : '#000',
        fontWeight: activeTab === key ? '500' : 'normal',
      }}
    >
      {icon}
      {label}
    </span>
  );

  return (
    <>
      {/* Inline style override for ink bar */}
      <style>
        {`
          .custom-tabs .ant-tabs-ink-bar {
            background-color: #722ED1 !important;
          }
        `}
      </style>

      <Card
        bodyStyle={{ padding: 0 }}
        style={{
          zIndex: 0,
          position: 'relative',
          marginBottom: '2px',
          boxShadow: 'none',
          border: 'none',
        }}
      >
        <div
          style={{
            background: '#fff',
            borderBottom: '1px solid #f0f0f0',
            paddingLeft: '25px',
            paddingTop: '8px',
            paddingBottom: '8px',
            paddingRight: '80px',
            position: 'fixed',
            top: '115px',
            width: '100%',
            left: '50px',
            zIndex: 1,
          }}
        >
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            tabBarStyle={{ marginBottom: 0 }}
            className="custom-tabs"
          >
            <TabPane
              tab={getTabLabel(
                'summaryDashboard',
                <AiOutlineDashboard />,
                'Summary Dashboard',
              )}
              key="summaryDashboard"
            />
            <TabPane
              tab={getTabLabel('Timeline', <AiOutlineNodeExpand />, 'Timeline')}
              key="Timeline"
            />
            <TabPane
              tab={getTabLabel(
                'backlog',
                <AiOutlineUnorderedList />,
                'Backlog',
              )}
              key="backlog"
            />
            <TabPane
              tab={getTabLabel('board', <AiOutlineForm />, 'Board')}
              key="board"
            />
            <TabPane
              tab={getTabLabel('list', <BsCardChecklist />, 'List')}
              key="list"
            />
          </Tabs>
        </div>
      </Card>
    </>
  );
};

export default Sidebar;
